import FetchDataset from '@engine/features/dashboard/chart/dashboard_chart_fetch';
import Top5 from '@engine/features/dashboard/top_5/dashboard_top5_line';
import { exists } from '@engine/lib/utility/exists';

function Top5Chart() {
  var date_from = '#dashboard_date_from';
  var date_to = '#dashboard_date_to';

  function entityName() {
    var path = window.location.pathname.split('/');
    return path[path.length - 1].replace('top_', '');
  }

  function fetchDataset() {
    var data = {
      entity: entityName(),
      date_from: $(date_from).val(),
      date_to: $(date_to).val()
    };
    FetchDataset.fetch('/dashboard/highchart_for_top_5/', data, function (response) {
      Top5.forceUpdate(response);
      Top5.updateDateRange(date_from, date_to);
    }, $('.dashboard-top-5').parent());
  }

  function initialize() {
    if (!exists($('#dashboard-top-5'))) {
      return;
    } // Initialize all components (Line, DateRange)


    Top5.create($('#dashboard-top-5'));
    Top5.updateDateRange(date_from, date_to); // Fetch real data and update all UI components

    fetchDataset(); // Prevent form submition

    $('#dashboard-form').on('submit', function (e) {
      e.preventDefault();
    }); // Update on button click

    var form_buttons = '#dashboard-form button, #dashboard-form input[type=submit]';
    $('body').on('click', form_buttons, function () {
      fetchDataset();
    });
  }

  return {
    initialize: initialize
  };
}

export default Top5Chart();